import Button3D from "@/components/orders/Button3D";
import { Checkbox } from "@/components/ui/checkbox";
import { describeProductLine } from "./templates";
import type { OrderProductLine } from "./types";

interface ProductSelectorProps {
  productLines: OrderProductLine[];
  selectedIds: Set<string>;
  onToggle: (lineId: string) => void;
  onContinue: () => void;
}

export const ProductSelector = ({
  productLines,
  selectedIds,
  onToggle,
  onContinue,
}: ProductSelectorProps) => {
  return (
    <div className="space-y-3">
      <div className="max-h-72 overflow-auto rounded-md border bg-background">
        {productLines.map((productLine) => {
          const checked = selectedIds.has(productLine.id);

          return (
            <label
              key={productLine.id}
              className="flex cursor-pointer items-start gap-3 border-b px-3 py-2 last:border-b-0 hover:bg-muted/40"
            >
              <Checkbox
                checked={checked}
                onCheckedChange={() => onToggle(productLine.id)}
                className="mt-0.5"
              />
              <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-medium text-foreground">
                  {describeProductLine(productLine)}
                </div>
                <div className="text-xs text-muted-foreground">
                  SKU {productLine.sku ?? "onbekend"}
                </div>
              </div>
            </label>
          );
        })}
      </div>

      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="text-xs text-muted-foreground">
          {selectedIds.size} {selectedIds.size === 1 ? "product geselecteerd" : "producten geselecteerd"}
        </div>
        <Button3D tone="primary" onClick={onContinue} disabled={selectedIds.size === 0}>
          Verder
        </Button3D>
      </div>
    </div>
  );
};
